import Vue from 'vue'
import Router from 'vue-router'

// Root
const HomePage = () => import(/* webpackChunkName: "home" */ '@/views/Home/Main.vue');
const AboutPage = () => import(/* webpackChunkName: "about" */ '@/views/AboutPage.vue');
const ProfilePage = () => import(/* webpackChunkName: "profile" */ '@/views/ProfilePage.vue');
const UsersPage = () => import(/* webpackChunkName: "users" */ '@/views/UsersPage.vue');
const ApiPage = () => import(/* webpackChunkName: "apis" */ '@/views/ApiPage.vue');
const PassPage = () => import(/* webpackChunkName: "apis" */ '@/views/PassPage.vue');
const SettingsPage = () => import(/* webpackChunkName: "settings" */ '@/views/SettingsPage.vue');
const ThemePage = () => import(/* webpackChunkName: "theme" */ '@/views/ThemePage.vue');
const LogPage = () => import(/* webpackChunkName: "log" */ '@/views/LogPage.vue');
const NotFoundPage = () => import(/* webpackChunkName: "notfound" */ '@/views/NotFoundPage.vue');

// By Channel ID
const ChannelPage = () => import(/* webpackChunkName: "channel" */ '@/views/ChannelPage.vue');
const EnrollmentPage = () => import(/* webpackChunkName: "enrollment" */ '@/views/EnrollmentPage.vue');
const ManagerPage = () => import(/* webpackChunkName: "manager" */ '@/views/ManagerPage.vue');

// Analytics
const AnalyticsMain = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Main/Main.vue');
const AnalyticsHome = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Home/Main.vue');
const AnalyticsExport = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Export/Main.vue');
const AnalyticsChannel = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Channel/Main.vue');
const AnalyticsStudent = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Student/Main.vue');

// By Media ID
const MediaPage = () => import(/* webpackChunkName: "media" */ '@/views/MediaPage.vue');
const QuizPage = () => import(/* webpackChunkName: "quiz" */ '@/views/QuizPage.vue');
const OverlayPage = () => import(/* webpackChunkName: "overlay" */ '@/views/OverlayPage.vue');
const TagPage = () => import(/* webpackChunkName: "tag" */ '@/views/TagPage.vue');
const SubmissionPage = () => import(/* webpackChunkName: "submission" */ '@/views/SubmissionPage.vue');
const VolatilityPage = () => import(/* webpackChunkName: "volatility" */ '@/views/VolatilityPage.vue');

// Embed Mode
const EmbedMedia = () => import(/* webpackChunkName: "embedmedia" */ '@/embed/Media.vue');

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFoundPage
    },
    {
      path: '/about',
      name: 'About',
      component: AboutPage
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ProfilePage
    },
    {
      path: '/settings',
      name: 'Settings',
      component: SettingsPage
    },
    {
      path: '/theme',
      name: 'Theme',
      component: ThemePage
    },
    {
      path: '/users',
      name: 'Users',
      component: UsersPage
    },
    {
      path: '/api',
      name: 'Api',
      component: ApiPage
    },
    {
      path: '/pass',
      name: 'Pass',
      component: PassPage
    },
    {
      path: '/log',
      name: 'Log',
      component: LogPage
    },
    {
      path: '/channel/:channelId',
      name: 'Channel',
      component: ChannelPage,
      props: true
    },
    {
      path: '/channel/:channelId/playlist/:playlistId',
      name: 'ChannelPlaylist',
      component: ChannelPage,
      props: true
    },
    {
      path: '/enrollment/:channelId',
      name: 'Enrollment',
      component: EnrollmentPage,
      props: true
    },
    {
      path: '/manager/:channelId',
      name: 'Manager',
      component: ManagerPage,
      props: true
    },
    {
      path: '/analytics/:channelId',
      component: AnalyticsMain,
      children: [
        {
          path: '',
          name: 'AnalyticsHome',
          component: AnalyticsHome
        },
        {
          path: 'export',
          name: 'AnalyticsExport',
          component: AnalyticsExport
        },
        {
          path: 'channel',
          name: 'AnalyticsChannel',
          component: AnalyticsChannel
        },
        {
          path: 'student',
          name: 'AnalyticsStudent',
          component: AnalyticsStudent
        },
        {
          path: 'student/:userId',
          name: 'AnalyticsStudent',
          component: AnalyticsStudent,
          props: true
        },
      ],
      props: true
    },

    {
      path: '/playlist/:playlistId',
      name: 'Playlist',
      component: MediaPage,
      props: true
    },
    {
      path: '/playlist/:playlistId/media/:mediaId',
      name: 'PlaylistMedia',
      component: MediaPage,
      props: true
    },

    {
      path: '/media/:mediaId',
      name: 'Media',
      component: MediaPage,
      props: true
    },
    {
      path: '/media/:mediaId/:startFrom',
      name: 'MediaStartFrom',
      component: MediaPage,
      props: true
    },
    {
      path: '/overlay/:mediaId',
      name: 'Overlay',
      component: OverlayPage,
      props: true
    },
    {
      path: '/submission/:mediaId',
      name: 'Submission',
      component: SubmissionPage,
      props: true
    },
    {
      path: '/volatility/:mediaId',
      name: 'Volatility',
      component: VolatilityPage,
      props: true
    },
    {
      path: '/quiz/:mediaId',
      name: 'Quiz',
      component: QuizPage,
      props: true
    },
    {
      path: '/tag/:mediaId',
      name: 'Tag',
      component: TagPage,
      props: true
    },

    {
      path: '/embed/:mediaId',
      name: 'EmbedMedia',
      component: EmbedMedia,
      props: true
    }
  ]
})
